export const navigation = [
  // {
  //   text: '업소고객사용현황',
  //   path: '/corp-list',
  //   icon: 'orderedlist',
  // },
  {
    text: '업소고객정보',
    path: '/corp-info',
    icon: 'product',
  },
  {
    text: '마일리지내역',
    path: '/card-bill-list',
    icon: 'search',
  },
  {
    text: '콜내역조회',
    path: '/call-service-search',
    icon: 'search',
  },
];
